module.exports = __webpack_public_path__ + "static/media/enviroment-corporate.118b59b4.svg";